var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 18",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5101 14H15.5101C15.2301 14 15.0101 13.78 15.0101 13.5V12.5C15.0101 12.22 15.2301 12 15.5101 12H16.0101V2H6.01013V2.5C6.01013 2.78 5.79013 3 5.51013 3H4.51013C4.23013 3 4.01013 2.78 4.01013 2.5V0.5C4.01013 0.22 4.23013 0 4.51013 0H17.5101C17.7901 0 18.0101 0.22 18.0101 0.5V13.5C18.0101 13.78 17.7901 14 17.5101 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5101 18H0.510132C0.230132 18 0.0101318 17.78 0.0101318 17.5V4.5C0.0101318 4.22 0.230132 4 0.510132 4H13.5101C13.7901 4 14.0101 4.22 14.0101 4.5V17.5C14.0101 17.78 13.7901 18 13.5101 18ZM2.01013 16H12.0101V6H2.01013V16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/IconCopy.e96d78888a857e7de1d8308c8af0ee2d.svg";
export { ForwardRef as ReactComponent };